import { render, staticRenderFns } from "./PropertyStructurePage.vue?vue&type=template&id=f3d7671a&"
import script from "./PropertyStructurePage.vue?vue&type=script&lang=ts&"
export * from "./PropertyStructurePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports